import * as React from 'react';
import { LucideIcon } from 'lucide-react';
import {
  seoMetricStatusClassName,
  type SeoMetricStatus,
} from 'features/DigitalMarketing/constants/seo';
import { DMDiv, DMText } from '../../../components/Primitives';

interface SeoMetricCardProps {
  label: string;
  value: string;
  status: SeoMetricStatus;
  icon: LucideIcon;
  iconClassName: string;
  iconBgClassName: string;
}

export const SeoMetricCard = ({
  label,
  value,
  status,
  icon: Icon,
  iconClassName,
  iconBgClassName,
}: SeoMetricCardProps) => (
  <DMDiv
    as="article"
    className="flex h-full min-h-0 items-center justify-between rounded-[0.7vh] bg-white px-[1.25vh] py-[0.85vh] shadow-[0_1px_8px_rgba(15,23,42,0.06)]"
  >
    <DMDiv className="flex min-w-0 items-center gap-[1.18vh]">
      <DMText
        as="span"
        className={`flex h-[3.6vh] w-[3.6vh] shrink-0 items-center justify-center rounded-[0.7vh] ${iconBgClassName}`}
        aria-hidden="true"
      >
        <Icon
          className={`h-[2.1vh] w-[2.1vh] ${iconClassName}`}
          strokeWidth={2.1}
        />
      </DMText>
      <DMText
        as="span"
        className="truncate text-[1.75vh] font-medium leading-none text-gray-950"
      >
        {label}
      </DMText>
    </DMDiv>

    <DMDiv className="flex shrink-0 flex-col items-end gap-[0.85vh]">
      <DMText
        as="span"
        className={`rounded-[0.72vh] px-[1vh] py-[0.48vh] text-[1.28vh] font-medium leading-none ${seoMetricStatusClassName[status]}`}
      >
        {status}
      </DMText>
      <DMText
        as="span"
        className="text-[1.75vh] font-bold leading-none text-gray-950"
      >
        {value}
      </DMText>
    </DMDiv>
  </DMDiv>
);
